export default __webpack_public_path__ + "static/media/thumbnail.38c6d764.jpg";